import { network } from './network';

export async function queryTopRoles(opts) {
	const res = await network({
		url: '/api/v1/web/public/top_roles',
		method: 'post',
		params: {
			...opts
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}

export async function queryRolesFilterTabs(opts) {
	const res = await network({
		url: '/api/v1/web/public/role_filter_types',
		method: 'post',
		params: {
			...opts
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}

export async function queryTabRoles(opts) {
	const res = await network({
		url: '/api/v1/web/public/role_list',
		method: 'post',
		params: {
			...opts
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}

export async function queryRoleDetail(opts) {
	const res = await network({
		url: '/api/v1/web/role_detail_public',
		method: 'post',
		params: {
			...opts
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}


